import { useTranslation } from 'i18n';
import { Alert, List, ListItem } from 'ui';

interface ProcessingErrorsProps {
  errors: {
    [key: string]: string[];
  }[];
}

export const ProcessingErrors = ({ errors }: ProcessingErrorsProps) => {
  const { t } = useTranslation('orders');

  return (
    <>
      {errors.map((rowError, index) => (
        <Alert severity="error" key={index} sx={{ mt: 1 }}>
          <strong>{t('financing.processingErrors.row', { values: { row: index + 1 } })}</strong>
          <List dense sx={{ listStyleType: 'disc', pl: 2 }}>
            {Object.entries(rowError).map(([field, errors]) => (
              <ListItem key={field} sx={{ display: 'list-item' }}>
                {field} - {errors[0]}
              </ListItem>
            ))}
          </List>
        </Alert>
      ))}
    </>
  );
};
